import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '../../../../foundations/typography';
import { Warning } from '../../../../foundations/icons';
import styles from './index.module.scss';
var FieldIconSubText = function (_a) {
    var text = _a.text;
    return (React.createElement("div", { className: styles.fieldIconSubText },
        React.createElement("span", { className: styles.iconWrapper },
            React.createElement(Warning, { className: styles.icon })),
        React.createElement("span", { className: styles.text },
            React.createElement(Typography, { "aria-live": "assertive", testId: "icon-subtext-text", styleAs: "paragraphSmallLight", element: "span", noMargins: true }, text))));
};
FieldIconSubText.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // |     To update them edit the d.ts file and run "yarn proptypes"     |
    // ----------------------------------------------------------------------
    text: PropTypes.string.isRequired,
};
export default FieldIconSubText;
//# sourceMappingURL=index.js.map